module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/FR-f82bdc9d59878c7f79bc58a503a5cb75.png";